// import Honeybadger from "@honeybadger-io/js"

// Honeybadger.configure({
//   apiKey: "5c9d1482",
//   environment: process.env.NODE_ENV,
//   revision: "git SHA/project version",
//   developmentEnvironments: ["dev", "development", "test", "staging"]
// })

const Honeybadger = {
  notify: (msg: string) => {
    console.log(msg)
  }
}

export default Honeybadger
